<template>
    <span v-if="price && price < 0"
          class="label label-success">- {{ currencyFilter(absPrice) }}</span>
    <span v-else-if="price && price > 0"
          class="label label-warning">+ {{ currencyFilter(price) }}</span>
</template>

<script>
export default {
    props: {
        price: {
            type: [Number, null],
            default: null,
        },
    },

    computed: {
        absPrice() {
            return this.price ? Math.abs(this.price) : null;
        },
    },
};
</script>
